// Styles
import Tabs from "components/Common/Tabs/Tabs";
import AlertsTab from "components/Screens/DailyRecs/DailyFlowsCheck/AlertsTab/AlertsTab";
import ChangeLogTab from "components/Screens/DailyRecs/DailyFlowsCheck/ChangeLogTab/ChangeLogTab";
import ReportsTab from "components/Screens/DailyRecs/DailyFlowsCheck/ReportsTab/ReportsTab";
import NTVsBBGMarketPricesContainer from "./NTVsBBGMarketPrices.styles";

interface NTVsBBGMarketPricesProps {}

const checkName = "nt_vs_bbg_market_prices";

const NTVsBBGMarketPrices = ({}: NTVsBBGMarketPricesProps) => {
    return (
        <NTVsBBGMarketPricesContainer>
            <p className={"sectionTitle"}>NT VS BBG MARKET PRICES</p>
            <Tabs
                defaultTab="reports"
                tabs={[
                    {
                        value: "reports",
                        title: "REPORTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: (
                            <ReportsTab
                                reportId="8521c12e-19c0-4fa8-8f87-e7ba61247f19"
                                workspaceId="a42e71f1-8daa-48e5-a1d6-ad5674016128"
                            />
                        ),
                    },
                    {
                        value: "alerts",
                        title: "ALERTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <AlertsTab checkName={checkName} />,
                    },
                    {
                        value: "change_log",
                        title: "CHANGE LOG",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <ChangeLogTab checkName={checkName} />,
                    },
                ]}
            />
        </NTVsBBGMarketPricesContainer>
    );
};

export default NTVsBBGMarketPrices;
